import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@mui/material';
import { LOGIN_AUTH0_PATH } from '../shared/constants';

export default function LogoutButton() {
  const { logout } = useAuth0();
  const logoutRedirect = `${window.location.origin}${LOGIN_AUTH0_PATH}`;

  return (
    <Button
      variant="text"
      type="button"
      sx={{
        color: 'white'
      }}
      onClick={() => logout({
        logoutParams: { returnTo: logoutRedirect },
      })}
    >
      Log Out
    </Button>
  );
}
